import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        position: 'absolute',
        top: '5px',
        right: '5px',
        color: theme.palette.info.main,
        opacity: 0.7,
        display: 'flex',
        flexDirection: 'column',

    },
    version: {
        lineHeight: 'unset !important',
    },
    date: {
        lineHeight: 'unset !important',
        fontSize: '0.5rem !important'
    }
}));
